function isMobile() {
  if (navigator.userAgent.match(/Mobi/)) {
    return true;
  }

  if ('screen' in window && window.screen.width < 600) {
    return true;
  }

  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection && connection.type === 'cellular') {
    return true;
  }
  if (window.innerWidth <= 520) {
    return true
  }
  return false;
}

function responsiveWidth() {
  return {
    small: window.innerWidth <= 768,
    middle: window.innerWidth > 769 && window.innerWidth < 1024,
    big: window.innerWidth >= 1024
  }
}

export default {
  isMobile,
  responsiveWidth
}